import React, { FC, useState, useEffect, useMemo } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { IncentiveFormMode } from '../../utils/common-utils';
import { fetchIncentiveItem } from '../../network/incentiveCrud';
import { IncentiveDetail } from '../../types/incentive-types';
import { useDispatch } from 'react-redux';
import { NOT_FOUND_ERROR_PAGE_PATH } from '../../../../common/constants';
import { LayoutSplashScreen } from 'src/app/layout';
import IncentiveDetailForm from './components/IncentiveDetailForm';

const IncentiveDetailPage: FC<RouteComponentProps> = ({ history, location }) => {
  const { id } = useParams<{id: string}>();
  const { formMode, code } = useMemo(() => ({
    formMode: id ? IncentiveFormMode.EDIT : IncentiveFormMode.CREATE,
    code: id ? id : undefined
  }), [id]);

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [incentiveDetail, setIncentiveDetail] = useState<IncentiveDetail>();
  const [lastFileName, setLastFileName] = useState<Pick<IncentiveDetail, 'bulletinFileName' | 'agentListFileName' | 'resultFileName'>>({
    bulletinFileName: undefined,
    agentListFileName: undefined,
    resultFileName: undefined
  });

  const reloadData = () => {
    if (code) {
      setIsLoading(true);
      fetchIncentiveItem(code, dispatch)
        .then(result => {
          setIncentiveDetail(result);
          setLastFileName({
            bulletinFileName: result.bulletinFileName,
            agentListFileName: result.agentListFileName,
            resultFileName: result.resultFileName
          });
        })
        .catch(() => {
          history.push(NOT_FOUND_ERROR_PAGE_PATH);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [code]);

  return (
    <>
      {formMode === IncentiveFormMode.CREATE &&
        <IncentiveDetailForm
          formMode={formMode}
          lastFileName={lastFileName}
          onReload={reloadData}
          onRouteTo={(route) => history.push(route)}
        />
      }
      {formMode === IncentiveFormMode.EDIT && (
        isLoading || !incentiveDetail ? (
          <LayoutSplashScreen />
        ) : (
          <IncentiveDetailForm
            code={code}
            formMode={formMode}
            incentiveDetail={incentiveDetail}
            lastFileName={lastFileName}
            onReload={reloadData}
            onRouteTo={(route) => history.push(route)}
          />
        )
      )}
    </>
  )
};

export default IncentiveDetailPage;
